// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars24: FC<Webinars24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M21 20.593v-16H3v8H1v-8c0-.55.196-1.021.587-1.413A1.926 1.926 0 0 1 3 2.593h18c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413v14c0 .55-.196 1.02-.587 1.412a1.926 1.926 0 0 1-1.413.588Zm-12-7c-1.1 0-2.042-.392-2.825-1.175C5.392 11.634 5 10.693 5 9.593s.392-2.042 1.175-2.825C6.958 5.984 7.9 5.593 9 5.593s2.042.391 2.825 1.175C12.608 7.55 13 8.493 13 9.593s-.392 2.041-1.175 2.825C11.042 13.2 10.1 13.593 9 13.593Zm0-2c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.021-.588-1.413A1.926 1.926 0 0 0 9 7.593c-.55 0-1.02.196-1.412.587A1.926 1.926 0 0 0 7 9.593c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Zm-8 10v-2.8c0-.567.146-1.088.438-1.563.291-.475.679-.837 1.162-1.087a14.843 14.843 0 0 1 3.15-1.163A13.755 13.755 0 0 1 9 14.593c1.1 0 2.183.129 3.25.387 1.067.259 2.117.646 3.15 1.163.483.25.87.612 1.162 1.087.292.475.438.996.438 1.563v2.8H1Zm2-2h12v-.8a.973.973 0 0 0-.5-.85c-.9-.45-1.808-.788-2.725-1.013a11.6 11.6 0 0 0-5.55 0c-.917.225-1.825.563-2.725 1.013a.973.973 0 0 0-.5.85v.8Z" />
        </svg>
    );
};

export default Webinars24;
